<template>
  <div>
    <v-container>
      <div style="display: flex;">
        <h2 class="primary--text mb-2">{{ $t('Total Users') }}</h2>
        <a
          href="https://tinyurl.com/yhfh6fd7"
          target="blank"
          style="align-self: center; margin-left: 6px; margin-bottom: 4px;"
          ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
        ></a>
      </div>
      <total-users></total-users>
    </v-container>
    <v-divider />
    <v-container>
      <h2 class="primary--text mb-2">{{ $t('New Users') }}</h2>
      <new-users></new-users>
    </v-container>
  </div>
</template>

<script>
import TotalUsers from './TotalUsers'
import NewUsers from './NewUsers'
export default {
  components: {
    TotalUsers,
    NewUsers
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/Overview.vue